import { render } from "./Gripper.vue?vue&type=template&id=7045f950"
const script = {}

import "./Gripper.vue?vue&type=style&index=0&id=7045f950&lang=scss"

import exportComponent from "/home/runner/work/serato-visualizer/serato-visualizer/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__